// Billing settings in the super admin's Edit billing dialog (views/billing-overview; the server checks who may
// change them: App\Billing in Laravel). A price per duty start is USD with up to 4 decimals; blank means the default rate. A billing
// start date is YYYY-MM-DD; blank means the company is not billed yet.

const RATE_PATTERN = /^\d{1,6}(\.\d{1,4})?$/;

// "0.10" from the server's "0.1000" ('' for none): the zeros past the cents left out
export function shortRate(rate) {
	if (rate === null || rate === undefined || String(rate).trim() === '') {
		return '';
	}
	const text = String(rate).trim();
	if (!RATE_PATTERN.test(text)) {
		return text;
	}
	const [whole, fraction = ''] = text.split('.');
	return String(Number(whole)) + '.' + fraction.replace(/0+$/, '').padEnd(2, '0');
}

// The message for a typed price that cannot be saved, or null when it is fine (blank is fine)
export function rateProblem(rate) {
	const text = rate === null || rate === undefined ? '' : String(rate).trim();
	if (text === '' || RATE_PATTERN.test(text)) {
		return null;
	}
	return 'The price per duty start must be a number of USD with up to 4 decimals, such as 0.10.';
}

// The message for a billing start date that cannot be saved, or null (blank is fine)
export function startDateProblem(date) {
	const text = date === null || date === undefined ? '' : String(date).trim();
	if (text === '') {
		return null;
	}
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
	if (match) {
		const d = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
		if (d.getUTCFullYear() === Number(match[1]) && d.getUTCMonth() === Number(match[2]) - 1 && d.getUTCDate() === Number(match[3])) {
			return null;
		}
	}
	return 'The billing start date must be a date (YYYY-MM-DD).';
}

// The day after a date ("2026-12-01" -> "2026-12-02"): billing starts the day after a free trial ends; null for a
// date that is not one.
export function dayAfter(date) {
	if (startDateProblem(date) || !date) {
		return null;
	}
	const [y, m, d] = String(date).trim().split('-').map(Number);
	return new Date(Date.UTC(y, m - 1, d + 1)).toISOString().slice(0, 10);
}
